<script>
    import hexadecimalToRgba from '@/util/hexadecimalToRgba';

    export default {
        name: 'ConductInspectionItemQuestionListResponse',
        props: {
            response: {
                type: Object,
                required: true,
            },
            selected: {
                type: Boolean,
                required: true,
            },
        },
        computed: {
            bgColor() {
                if (this.selected) {
                    return this.response.color;
                }

                return hexadecimalToRgba(this.response.color);
            },
            color() {
                if (this.selected) {
                    return '#ffffff';
                }
                return this.response.color;
            },
        },

        methods: {
            handleClick(event) {
                this.$emit('click', event.target.value);
            },
        },
    };
</script>

<template>
    <button
        class="response btn btn-default border whitespace-no-wrap"
        :value="response.uuid"
        :style="{
            color: color,
            'background-color': bgColor,
            'border-color': response.color
        }"
        :class="{ selected: selected }"
        @click="handleClick"
    >
        {{ response.title }}
    </button>
</template>
